import { ACTION_LOGOUT } from "app/modules/login/reducer/actions.type";
import {
  FETCH_STATEMENT_BACKUP_FAILURE,
  FETCH_STATEMENT_BACKUP_REQUEST,
  FETCH_STATEMENT_BACKUP_SUCCESS,
  FETCH_STATEMENT_DETAIL_FAILURE,
  FETCH_STATEMENT_DETAIL_REQUEST,
  FETCH_STATEMENT_DETAIL_SUCCESS,
  FETCH_STATEMENT_V2_FAILURE,
  FETCH_STATEMENT_V2_REQUEST,
  FETCH_STATEMENT_V2_SUCCESS,
  RESET_STATEMENT_BACKUP,
  SET_STATEMENT,
  SET_STATEMENT_RESET,
} from "./actions.type";
import { StatementActions, StatementState } from "./types";

const initialState: StatementState = {
  statement: undefined,
  // Xuất sổ phụ
  responseStatementBackup: undefined,
  statusResponseStatementBackup: "init",
  errorResponseStatementBackup: {
    code: "",
    message: "",
  },
  responseStatementV2: undefined,
  pending: false,
  // Lấy chi tiết giao dịch
  statusStatementDetail: "pending",
  responseStatementDetail: undefined,
  errorStatementDetail: {
    code: "",
    message: "",
  },
};

export default (state = initialState, action: StatementActions): StatementState => {
  switch (action.type) {
    case SET_STATEMENT:
      return {
        ...state,
        ...action.payload,
      };
    // Lấy dữ liệu xuất sổ phụ
    case FETCH_STATEMENT_BACKUP_REQUEST:
      return {
        ...state,
        statusResponseStatementBackup: "pending",
        statement: action.payload,
        responseStatementBackup: undefined,
      };
    case FETCH_STATEMENT_BACKUP_SUCCESS:
      return {
        ...state,
        statusResponseStatementBackup: "ok",
        responseStatementBackup: action.payload,
      };
    case FETCH_STATEMENT_BACKUP_FAILURE:
      return {
        ...state,
        statusResponseStatementBackup: "error",
      };
    case RESET_STATEMENT_BACKUP:
      return {
        ...state,
        statusResponseStatementBackup: "init",
        responseStatementBackup: undefined,
        errorResponseStatementBackup: {
          code: "",
          message: "",
        },
      };
    case FETCH_STATEMENT_V2_REQUEST:
      return {
        ...state,
        pending: true,
        responseStatementV2: undefined,
        responseStatementBackup: undefined,
        responseStatementDetail: undefined,
        statement: action.payload,
      };
    case FETCH_STATEMENT_V2_SUCCESS:
      return {
        ...state,
        pending: false,
        responseStatementV2: action.payload,
      };
    case FETCH_STATEMENT_V2_FAILURE:
      return {
        ...state,
        pending: false,
      };

    // Chi tiết giao dịch
    case FETCH_STATEMENT_DETAIL_REQUEST:
      return {
        ...state,
        responseStatementDetail: undefined,
        statusStatementDetail: "pending",
        errorStatementDetail: {
          code: "",
          message: "",
        },
      };
    case FETCH_STATEMENT_DETAIL_SUCCESS:
      return {
        ...state,
        responseStatementDetail: action.payload,
        statusStatementDetail: "ok",
      };
    case FETCH_STATEMENT_DETAIL_FAILURE:
      return {
        ...state,
        statusStatementDetail: "error",
        errorStatementDetail: {
          code: action.error?.code || "",
          message: action.error?.message || "",
        },
      };
    case SET_STATEMENT_RESET:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
